<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="" title="Technicians" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-12">
										<router-link :to="{ name: 'add_technician' }" class="btn btn-primary float-end">Add Technician</router-link>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-8 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchTechnicians()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="status" @change="fetchTechnicians()">
											<option value="">All</option>
                                            <option value="1">Active</option>
                                            <option value="2">Blocked</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1" placeholder="Search" v-model="keyword" @keyup="fetchTechnicians()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>ID</th>  
                                            <th>Name</th>
											<th>Contact</th>
											<th>Status</th> 
											<th>Works Completed</th>
											<th>Options</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(technicians.length)">
                                        <tr align="center" v-for="(technician, index) in technicians" :key="index">
                                            <td>{{ (from - 1) + index + 1 }}</td>
                                            <td>{{ technician.name }}</td>
											<td>{{ technician.country_code + " " + technician.mobile}} <br>
												{{ technician.email }}
											</td>
											<td>
												<span v-if="technician.status == 1" class="badge rounded-pill bg-success">Active</span>
												<span v-else class="badge rounded-pill bg-warning">Blocked</span>											
											</td>
											<td>{{ technician.job_count }}</td>
											<td>
												<router-link :to="{ name: 'technician_details', query: { id: technician.id } }" class="btn btn-primary me-1 mb-2 btn-sm">Profile</router-link>
												<router-link :to="{ name: 'technician_jobs', query: { id: technician.id } }" class="btn btn-primary me-1 mb-2 btn-sm">Works</router-link><br>
												<router-link :to="{ name: 'edit_technician', query: { id: technician.id } }" class="btn btn-primary me-1 mb-2 btn-sm">Edit</router-link>
												<router-link :to="{ name: 'technician_products', query: { id: technician.id } }" class="btn btn-primary me-1 mb-2 btn-sm">Products</router-link>
                                                <button v-if="technician.status == 1" class="btn btn-warning btn-sm me-1 mb-2" @click="updateTechnicianStatus(technician.id, 2)">Block</button>
					                            <button v-else class="btn btn-success btn-sm me-1 mb-2" @click="updateTechnicianStatus(technician.id, 1)">Activate</button>
												<router-link :to="{ name: 'technician_travel_log', query: { id: technician.id } }" class="btn btn-primary me-1 mb-2 btn-sm">Travel Log</router-link>
												<button class="btn btn-danger btn-sm me-1 mb-2" @click="deleteTechnician(technician.id)">Delete</button>
                                            </td>
                                        </tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="6" class="text-center">No technicians found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
									<a class="page-link" href="#" @click.prevent="fetchTechnicians(page.url)" tabindex="-1">
										<span v-if="index === 0">Prev</span>
										<span v-else-if="index === pagination.length - 1">Next</span>
										<span v-else v-html="page.label"></span>
									</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script setup>
import { get, post } from '@/utils/api';
import { useRouter } from 'vue-router';
import { ref, onMounted } from 'vue';
import { routes } from '@/constants/routes';
import Swal from '@/utils/swal';

const router = useRouter();

const keyword = ref("");
const listing_length = ref(10);
const errors = ref({});
const status = ref("");
const technicians = ref([]);
const from = ref(null);
const to = ref(null);
const total = ref(null);
const pagination = ref({});

const fetchTechnicians = (url = null) => {
	
	const params = {
		limit: listing_length.value,
		status: status.value,
		keyword: keyword.value
	}

	const requestUrl = url ?? routes.Technicians;

	get(requestUrl, { params }, false)
		.then((response) => {
			if(response.status === 200){
				console.log(response.data.data);
				technicians.value = response.data.data.data;
				pagination.value = response.data.data.links;
				from.value = response.data.data.from;
				to.value = response.data.data.to;
				total.value = response.data.data.total;
			} else {
				Swal.fire('', response.data.message || 'Failed to fetch technicians', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				Swal.fire('', error.response.data.message.limit?.[0] || error.response.data.message.status?.[0] || error.response.data.message.keyword?.[0] || 'Validation error', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

const updateTechnicianStatus = (technician_id, status) => {
	
	const params = {
		technician_id: technician_id,
		status: status
	}

	get(routes.UpdateTechnicianStatus, { params }, false)
		.then((response) => {
			if(response.status === 200){
				Swal.fire('', response.data.message || 'Technician status updated successfully', 'success');
				fetchTechnicians();
			} else {
				Swal.fire('', response.data.message || 'Error in updating technician status', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				Swal.fire('', error.response.data.message.technician_id[0] || error.response.data.message.status[0] || 'Validation error', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		})
}

const deleteTechnician = (technician_id) => {

	const params = {
		technician_id: technician_id
	}

	get(routes.DeleteTechnician, { params }, false)
		.then((response) => {
			if(response.status === 200){
				Swal.fire('', response.data.message || 'Technician deleted successfully', 'success');
				fetchTechnicians();
			} else {
				Swal.fire('', response.data.message || 'Failed to delete technician', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				Swal.fire('', error.response.data.message.technician_id[0] || 'Validation error', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		})
}

onMounted(() => {
	fetchTechnicians();
});


</script>